<template>
  <div>
    <div class="page-header clear-filter" filter-color="red">
      <parallax class="page-header-image" style="background-image:url('img/principal.jpg')"></parallax>
      <div class="container">
        <div class="content-center brand" id="somos">
          <img class="n-logo" src="img/logo_romida.png" alt="" />
          <h3>Somos una empresa MEXICANA con más de 22 años de experiencia en el mercado, mismos que nos ha dado el conocimiento para atender y resolver las necesidades de nuestros clientes y con ello contar con su confianza y recomendación.</h3>
        </div>
      </div>
    </div>
    <br>
    <Enfoques id="enfoques" style="scroll-margin-top: 100px;"></Enfoques>
    <br>
    <Giros id="giros" style="scroll-margin-top: 100px;"></Giros>
    <br>
    <Marcas id="marcas" style="scroll-margin-top: 100px;"></Marcas>
    <br>
    <Mision id="mision" style="scroll-margin-top: 100px;"></Mision>
    <br>
    <Vision id="vision" style="scroll-margin-top: 100px;"></Vision>
    <br>
    <Valores id="valores" style="scroll-margin-top: 100px;"></Valores>
    <br>
    <PoliticasCalidad id="politicas" style="scroll-margin-top: 100px;"></PoliticasCalidad>
    <br>
    <PolotocasSeguridad id="seguridad" style="scroll-margin-top: 100px;"></PolotocasSeguridad>
    <br>
    <carousel-section id="carousel" style="scroll-margin-top: 100px;"></carousel-section>
    <br>
    <Contacto id="contacto"></Contacto>
  </div>
</template>

<script>
import { Parallax } from '@/components';
import Enfoques  from './components/Enfoques';
import Giros  from './components/Giros';
import Marcas from './components/Marcas';
import Mision from './components/Mision';
import Vision from './components/Vision';
import Valores from './components/Valores';
import PoliticasCalidad from './components/PoliticasCalidad.vue';
import PolotocasSeguridad from './components/PoliticasSeguridad';
import CarouselSection from './components/CarouselSection';
import Contacto from './components/Contacto';

export default {
  name: 'index',
  bodyClass: 'index-page',
  components: {
    Parallax,
    Enfoques,
    Giros,
    Marcas,
    Mision,
    Vision,
    Valores,
    PoliticasCalidad,
    PolotocasSeguridad,
    CarouselSection,
    Contacto
  }
};
</script>
<style></style>
